import { render, staticRenderFns } from "./service-point.vue?vue&type=template&id=3b40745c&scoped=true"
import script from "./service-point.vue?vue&type=script&lang=js"
export * from "./service-point.vue?vue&type=script&lang=js"
import style0 from "./service-point.vue?vue&type=style&index=0&id=3b40745c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b40745c",
  null
  
)

export default component.exports